import { render, staticRenderFns } from "./SMSPreviewComponent.vue?vue&type=template&id=7f5dccd3"
import script from "./SMSPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./SMSPreviewComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports